import React from "react";
import classNames from "classnames";
import { HtmlRenderer } from "../../../../components/html-render/HtmlRenderer";
import { BaseProps } from "./base";
import Styles from "../AnswerDetails.module.scss";
import Editor from "../../../../components/agent-v3/editor/Editor";

// eslint-disable-next-line import/prefer-default-export
export function HtmlBlock(props: BaseProps) {
    if (props.isReadOnly) {
        return (
            <HtmlRenderer
                key={props.section.id}
                html={props.section?.text?.body?.html ?? ""}
                className={classNames(
                    Styles["article-preview"],
                    Styles[`article-preview-${props.section.type.toLowerCase()}`],
                )}
            />
        );
    }
    return (
        <Editor
            value={props.section?.text?.body?.html ?? ""}
            onChange={value => {
                const copy = {
                    ...props.section,
                    text: {
                        ...props.section.text,
                        body: {
                            ...props.section.text?.body,
                            html: value,
                        },
                    },
                };
                props.onChange?.(copy);
            }}
            size="auto"
            rootClassName={classNames(Styles["article-editor"], props.className)}
            hasBorder
            isRequired
            isAllowHeaders
            placeholder="The story begins with..."
        />
    );
}
